import React from 'react'
import PropTypes from 'prop-types'
import FormX from 'sb-formx'
import actions from 'redux/actions'
import { useConnect } from 'sb-redux-hook'
import { useCallback, useWillMount } from 'sb-hooks'
import { constants } from 'common/helpers'
import { required, email } from 'helpers/validation'
import { FormattedMessage } from 'sb-react-intl'

import Field from 'components/_new/forms/Field/Field'
import BackNextModal from 'components/modal/BackNextModal/BackNextModal'

import messages from './messages'
import s from './SetGiftRecipientInfoModal.scss'


const form = new FormX({
  fields: {
    name: [ required ],
    email: [ required, email ],
    message: [ ],
  },
})


const SetGiftRecipientInfoModal = (props) => {
  const { name, onClose, data: { onBack, onNext } } = props

  const { initialValues } = useConnect({
    initialValues: (state) => {
      const { view: { giftPage: { name, email, message } } } = state

      return {
        name,
        email,
        message,
      }
    },
  })

  useWillMount(() => {
    form.setInitialValues(initialValues)
  })

  const handleClose = useCallback(() => {
    actions.models.modals.close(name)

    if (typeof onClose === 'function') {
      onClose()
    }
  }, [])

  const handleBack = useCallback(() => {
    handleClose()
    onBack()
  }, [])

  const handleSubmit = useCallback((event) => {
    event.preventDefault()

    form.submit()
      .then(({ name, email, message }) => {
        handleClose()
        onNext({ name, email, message })
      })
  }, [])

  return (
    <BackNextModal
      className={s.setGiftRecipientInfoModal}
      name={name}
      nextButtonId="giftPersonNextButton"
      dataTestId={constants.testIds.modal.setGiftRecipientInfoModal}
      onClose={handleClose}
      onBack={handleBack}
      onNext={handleSubmit}
    >
      <FormattedMessage className={s.title} tag="div" {...messages.title} />
      <Field
        className={s.field}
        id="giftModalRecipientName"
        field={form.fields.name}
        placeholder={messages.nameLabel}
        standardView
      />
      <Field
        className={s.field}
        id="giftModalRecipientEmail"
        field={form.fields.email}
        placeholder={messages.emailLabel}
        standardView
      />
      <FormattedMessage className={s.hint} tag="label" for="giftModalPersonalMessage" {...messages.hint} />
      <Field
        className={s.field}
        id="giftModalPersonalMessage"
        field={form.fields.message}
        standardView
        rows={5}
      />
    </BackNextModal>
  )
}

SetGiftRecipientInfoModal.propTypes = {
  data: PropTypes.shape({
    onNext: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
  }),
  name: PropTypes.string,
  onClose: PropTypes.func,
}

SetGiftRecipientInfoModal.defaultProps = {
  name: constants.modals.gifts.SetGiftRecipientInfo,
}


export default SetGiftRecipientInfoModal
